import { Box, IconButton } from '@mui/material';
import { mdiBellRing, mdiBellOff } from '@mdi/js';
import { useTranslation } from 'react-i18next';

import { Icon } from 'common/components/Icon';
import { Tooltip } from 'common/components/Tooltip';

interface IProps {
    active?: boolean;
    disabled?: boolean;
    onClick?(): void;
}

export const NotificationButton = ({ active, disabled, onClick }: IProps) => {
    const [translate] = useTranslation();

    const description = translate(
        active ? 'notificationsOff' : 'notificationsOn'
    );

    return (
        <Tooltip title={description}>
            <Box>
                <IconButton
                    aria-label={description}
                    color="inherit"
                    disabled={disabled}
                    size="large"
                    onClick={onClick}
                >
                    <Icon
                        path={active ? mdiBellRing : mdiBellOff}
                        size="2.4rem"
                    />
                </IconButton>
            </Box>
        </Tooltip>
    );
};
